export default __webpack_public_path__ + "static/media/premium-symbol.2ff16e09.svg";